import {config} from '../config';
import {handleResponse} from "../helpers/response";
import i18n from 'i18next';

export const RECEIVED_FILTERS = 'RECEIVED_FILTERS';
export const ADD_NEW_FILTER_VALUE = 'ADD_NEW_FILTER_VALUE';
export const REMOVE_FILTER_VALUE = 'REMOVE_FILTER_VALUE';
export const CHANGE_RANGE_FILTER= "CHANGE_RANGE_FILTER";

export function receivedFiltersList( category, isSpecificCategory ){
    return (dispatch, getState) => {
        // console.log("getSTate received filters ", getState());
        let link = config.apiUrl + 'filters/smart/'+category+'/'+i18n.language+"?isSpecific="+isSpecificCategory;
        fetch(link).then( handleResponse ).then( json => {
            // console.log( "data filters ", json );
            dispatch( receivedFilters( json  ) );
        });
    }
}

/**
 *Received filters
 *
 * @param RECEIVED_FILTERS
 * @returns {{dataMenu: *, type: *}}
 */
export function receivedFilters(dataFilters){
    return {
        type: RECEIVED_FILTERS,
        dataFilters: dataFilters
    }
}

export function addFilter(value_id, conditionFilter){
    return {
        type: ADD_NEW_FILTER_VALUE,
        filter: value_id,
        conditionFilter: conditionFilter
    }
}

export function removeFilter(value_id, conditionFilter){
    return {
        type: REMOVE_FILTER_VALUE,
        filter: value_id,
        conditionFilter: conditionFilter
    }
}

/**
 *
 * @param filterMin
 * @param filterMax
 * @param filterId
 * @returns {{filterId: *, filterMax: *, type: string, filterMin: *}}
 */
export function changeRangeFilter(filterMin, filterMax, filterId){
    return {
        type: CHANGE_RANGE_FILTER,
        filterMin: filterMin,
        filterMax: filterMax,
        filterId: filterId,
    }
}